module.exports = __webpack_public_path__ + "img/bg_5.f8286d20.png";